import React from 'react'
import { useSelector } from 'react-redux'
import Slider from 'react-slick'
import { Card, Box, Stack } from '@mui/material'
import { setcurrentPair, setPairType } from '../Trader/tradingSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const CoinSlide = () => {

  const coinRates = useSelector((state) => state.coins.coinRates)
 const dispatch = useDispatch();
  const navigate = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  }

  return (
    <Card>
    <Stack sx={{bgcolor: 'inherit'}}>
      <Slider {...settings}>
        {coinRates && coinRates.map((coin) => (
          <div key={coin.symbol}
          onClick={()=>{
            if (coin.symbol === 'USDT') {
              dispatch(setcurrentPair('BTC'));
            }else{
              dispatch(setcurrentPair(coin.symbol));
            }
            dispatch(setPairType('crypto'));

            setTimeout(() => {
              navigate('/trading-page');
            }, 100);
        }}
          >
            <div className={`coin-card ${parseFloat(coin.changePercent24Hr) >= 0 ? 'positive' : 'negative'}`}>
              <span className="coin-pair">{coin.symbol}</span>
              <span className={`percentage-change ${parseFloat(coin.changePercent24Hr) >= 0 ? 'positive' : 'negative'}`}>
                {parseFloat(coin.changePercent24Hr) >= 0 ? '+' : ''}
                {parseFloat(coin.changePercent24Hr).toFixed(2)}%
              </span>
            </div>
          </div>
        ))}
      </Slider>
      <style jsx>{`
        .slider-container {
          width: 100%;
          padding: 10px;
        }
        .coin-card {
          margin: 0 10px;
          padding: 8px 5px;
          border-radius: 2px;
          cursor: pointer;
          min-width: max-content;
        }
        .coin-card.positive {
          background-color: rgba(14, 203, 129, 0.1);
        }
        .coin-card.negative {
          background-color: rgba(246, 70, 93, 0.1);
        }
        .coin-pair {
          color: #fff;
          font-weight: 500;
          margin-right: 10px;
        }
        .percentage-change.positive {
          color: #0ECB81;
        }
        .percentage-change.negative {
          color: #F6465D;
        }
      `}</style>
      </Stack>
    </Card>
  )
}

export default CoinSlide
